<template>
  <section class="container content-padding">
    <template v-if="state === -1">
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <form @submit.prevent="submitPrepareState('state-1')" data-vv-scope="state-1">

            <p>กรุณากรอกเลขที่บัตรประชาชนเพื่อเข้าสู่แบบฟอร์มการสมัครค่ะ</p>
            <div class="form-group">
              <input type="number"
                     name="idCardNumber"
                     :class="[{'form-alert': errors.has('state-1.idCardNumber')},'form-control','input-lg']"
                     placeholder="เลขที่บัตรประชาชน"
                     @keypress="filterOnlyNumber($event)"
                     v-validate="'required|length:13'"
                     v-model="idCardNumber">
              <div v-if="errors.has('state-1.idCardNumber')" class="form-alert-text -status-alert">
                กรุณากรอกเลขที่บัตรประชาชนให้ครบทั้ง 13 หลัก
              </div>
            </div>

            <div class="form-group">
              <input type="number"
                     name="tel"
                     class="form-control input-lg"
                     :class="{'form-alert': errors.has('state-1.tel')}"
                     placeholder="เบอร์โทร (กรอกเฉพาะตัวเลขและพิมพ์ติดกัน)"
                     @keypress="filterOnlyNumber($event)"
                     v-validate="'required'"
                     v-model="generalInfoSubmitData.tel">
              <div v-if="errors.has('state-1.tel')" class="form-alert-text -status-alert">กรุณากรอกเบอร์โทรศัพท์</div>
            </div>

            <div class="form-group form-check">
              <input class="form-check-input" type="checkbox"
                     :true-value="1" :false-value="0"
                     id="accept_protect_personal_information" v-model="isAcceptPersonalInformation"
                     value="1">
              <label class="form-check-label ml-2" for="accept_protect_personal_information">
                ยอมรับเงื่อนไขนโยบายคุ้มครองข้อมูลส่วนบุคคลและยินยอมให้เปิดเผยข้อมูลส่วนบุคคล <a target="_blank" download href="/static/pdf/เอกสารแสดงความยินยอมให้เปิดเผยข้อมูลส่วนบุคคล_beneat.pdf">ดูเพิ่มเติม</a>
              </label>
            </div>

            <div class="form-group">
              <button :class="['button-large button-block', isAcceptPersonalInformation ? '-cyan' : '']" :disabled="!isAcceptPersonalInformation" type="submit">
                <label>ต่อไป</label>
              </button>
            </div>

            <div class="form-group mt-5">
              <router-link to="/service-provider-privacy" tag="a" style="text-decoration: underline;">นโยบายความเป็นส่วนตัวของผู้ให้บริการ Service Provider Privacy Notice</router-link>
            </div>
          </form>

        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-xs-12 my-3">
          <img src="/static/img/training00.jpg" alt="" class="img-fluid">
        </div>
        <div class="col-md-4 col-xs-12 my-3">
          <img src="/static/img/training01.jpg" alt="" class="img-fluid">
        </div>
        <div class="col-md-4 col-xs-12 my-3">
          <img src="/static/img/training02.jpg" alt="" class="img-fluid">
        </div>
      </div>
    </template>
    <div v-else-if="state === 0">
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <h3>ข้อมูลทั่วไป</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <div class="form-group">

            <div class="row mb-md-4">
              <div class="col-md-6 col-xs-12 pl-0 pr-0" :class="{'pr-2': !$mq.phone, 'py-2': $mq.phone}">
                <select name="title_th" id="title_th" v-model="generalInfoSubmitData.title_th"
                        :class="[{'form-alert': errors.has('title_th')},'form-control']"
                        v-validate="'required'">
                  <option value="">คำนำหน้าชื่อ</option>
                  <option value="นาย">นาย</option>
                  <option value="นาง">นาง</option>
                  <option value="นางสาว">นางสาว</option>
                </select>
                <div v-if="errors.has('title_th')" class="form-alert-text -status-alert">กรุณาระบุคำนำหน้า</div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 col-xs-12 pl-0 pr-0" :class="{'pr-2': !$mq.phone, 'py-2': $mq.phone}">
                <input type="text"
                       name="firstName"
                       class="form-control input-lg"
                       :class="{'form-alert': errors.has('firstName')}"
                       placeholder="ชื่อ"
                       v-validate="'required'"
                       v-model="generalInfoSubmitData.firstname">
                <div v-if="errors.has('firstName')" class="form-alert-text -status-alert">กรุณากรอกชื่อ</div>
              </div>
              <div class="col-md-6 col-xs-12 pl-0 pr-0" :class="{'pl-2': !$mq.phone}">
                <input type="text"
                       name="lastName"
                       class="form-control input-lg"
                       :class="{'form-alert': errors.has('lastName')}"
                       placeholder="นามสกุล"
                       v-validate="'required'"
                       v-model="generalInfoSubmitData.lastname">
                <div v-if="errors.has('lastName')" class="form-alert-text -status-alert">กรุณากรอกนามสกุล</div>
              </div>
            </div>

            <p class="mt-2 mb-1">ท่านเคยเปลี่ยน ชื่อ - นามสกุล หรือไม่?</p>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="nameChanged" id="nameChanged1" v-model="nameChanged"
                     :value="0"
                     v-validate="'required'">
              <label class="form-check-label ml-2" for="nameChanged1">
                ไม่เคย
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="nameChanged" id="nameChanged2" v-model="nameChanged"
                     :value="1">
              <label class="form-check-label ml-2" for="nameChanged2">
                เคย
              </label>
            </div>

            <div class="row mt-2 mb-4" v-if="nameChanged">
              <div class="col-md-6 col-xs-12 pl-0 pr-0" :class="{'pr-2': !$mq.phone, 'py-2': $mq.phone}">
                <input type="text"
                       name="prevFirstName"
                       class="form-control input-lg"
                       :class="{'form-alert': errors.has('prevFirstName')}"
                       placeholder="ชื่อเดิม"
                       v-validate="'required'"
                       v-model="generalInfoSubmitData.prev_firstname">
                <div v-if="errors.has('prevFirstName')" class="form-alert-text -status-alert">กรุณากรอกชื่อเดิม</div>
              </div>
              <div class="col-md-6 col-xs-12 pl-0 pr-0" :class="{'pl-2': !$mq.phone}">
                <input type="text"
                       name="prevLastName"
                       class="form-control input-lg"
                       :class="{'form-alert': errors.has('prevLastName')}"
                       placeholder="นามสกุลเดิม"
                       v-validate="'required'"
                       v-model="generalInfoSubmitData.prev_lastname">
                <div v-if="errors.has('prevLastName')" class="form-alert-text -status-alert">กรุณากรอกนามสกุลเดิม</div>
              </div>
            </div>


            <input type="text"
                   name="email"
                   class="form-control input-lg"
                   :class="{'form-alert': (errors.has('email') && generalInfoSubmitData.email.trim())}"
                   placeholder="อีเมล (หากไม่มีไม่ต้องกรอก)"
                   v-validate="'email'"
                   v-model="generalInfoSubmitData.email">
            <div v-if="errors.has('email') && generalInfoSubmitData.email.trim()" class="form-alert-text -status-alert">อีเมลไม่ถูกต้อง</div>

            <input type="text"
                   name="facebook"
                   class="form-control input-lg my-4"
                   placeholder="ชื่อเฟสบุ๊ค (Facebook)"
                   v-model="generalInfoSubmitData.facebook">

            <input type="text"
                   name="line"
                   class="form-control input-lg my-4"
                   placeholder="ไอดีไลน์ (Line ID)"
                   v-model="generalInfoSubmitData.line">


            <div class="form-group my-4">
              <div class="row">
                <div class="col-12 p-0">
                  <label for="">วันเกิด</label>
                </div>
              </div>
              <div class="row">
                <div class="col-3 p-0">
                  <select id="day" class="form-control ml-1" name="birth_day"
                          :class="{'form-alert': errors.has('birth_day')}" v-validate="'required'"
                          v-model="birthDateData.birth_day">
                    <option value="">วัน</option>
                    <option v-for="(day, index) in 31" :value="day < 10 ? '0' + day : day.toString()" :key="'day_'+index">
                      {{ day }}
                    </option>
                  </select>
                </div>
                <div class="col-5">
                  <select id="month" class="form-control ml-1"
                          name="birth_month"
                          :class="{'form-alert': errors.has('birth_month')}" v-validate="'required'"
                          v-model="birthDateData.birth_month">
                    <option value="">เดือน</option>
                    <option :value="month.month < 10 ? '0' + month.month : month.month.toString()" v-for="(month, index) in birthMonths" :key="'month_'+index">
                      {{ month.name }}
                    </option>
                  </select>
                </div>
                <div class="col-4 p-0">
                  <select id="year" class="form-control ml-1"
                          name="birth_year"
                          :class="{'form-alert': errors.has('birth_year')}" v-validate="'required'"
                          v-model="birthDateData.birth_year">
                    <option value="">ปี (พ.ศ.)</option>
                    <option v-for="year in birthYears" :value="year" :key="'year_' + year">{{ year }}</option>
                  </select>
                </div>

              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div v-if="errors.has('birth_day')" class="form-alert-text -status-alert">กรุณาระบุ วันเกิด</div>
                  <div v-if="errors.has('birth_month')" class="form-alert-text -status-alert">กรุณาระบุ เดือนเกิด</div>
                  <div v-if="errors.has('birth_year')" class="form-alert-text -status-alert">กรุณาระบุ ปีเกิด</div>
                </div>
              </div>
            </div>
            <!--
            <div class="form-group my-4">
                <label>วัน เดือน ปี เกิด</label>
                <input type="text"
                       ref="birthday"
                       name="birthday"
                       class="form-control -date-picker input-jumbo"
                       :class="{'form-alert': errors.has('birthday')}"
                       v-validate="'required'"
                       placeholder="วัน / เดือน / ปี ค.ศ."
                       @change="updateBirthDay()"
                       v-pikadayProfessionalRegister="birthday">
                <div v-if="errors.has('birthday')" class="form-alert-text -status-alert">กรุณากรอกวันเดือนปีเกิด</div>
              </div>-->


            <div class="form-group my-4">
              <label>จังหวัดที่ต้องการสมัคร</label>
              <div class="select-jumbo">
                <select class="form-control" :class="{'form-alert': errors.has('province')}"
                        v-model="generalInfoSubmitData.province_id"
                        @change="changeProvince($event)"
                        name="province" v-validate="'required'">
                  <option value="">โปรดระบุ</option>
                  <option :value="1">กรุงเทพ (ฝั่งพระนคร)</option>
                  <option :value="11">กรุงเทพ (ฝั่งธนบุรี)</option>
                  <option :value="6">นนทบุรี</option>
                  <option :value="7">ปทุมธานี</option>
                  <option :value="8">สมุทรปราการ</option>
                  <option :value="9">สมุทรสาคร</option>
                  <option :value="10">นครปฐม</option>
                  <option :value="2">เชียงใหม่</option>
                  <option :value="3">ภูเก็ต</option>
                  <option :value="4">ชลบุรี</option>
                  <option :value="5">ระยอง</option>
                  <option :value="0">อื่น ๆ (โปรดระบุ)</option>
                </select>
              </div>
              <input type="text"
                     name="provinceOther"
                     class="form-control input-md my-2"
                     :class="{'form-alert': errors.has('provinceOther')}"
                     v-validate="'required'"
                     placeholder="(โปรดระบุ)"
                     v-if="generalInfoSubmitData.province_id === 0"
                     v-model="generalInfoSubmitData.province_other">
              <div v-if="errors.has('province')" class="form-alert-text -status-alert">
                กรุณาเลือกจังหวัดที่ต้องการสมัคร
              </div>
              <div v-if="errors.has('provinceOther')" class="form-alert-text -status-alert">กรุณาระบุจังหวัด</div>
            </div>

            <div class="form-group my-4" v-if="generalInfoSubmitData.province_id !== 0">
              <label for="service_districts">อำเภอ / เขต (ที่สะดวกรับงาน)</label>
              <br>
              <span style="font-style: italic;">สามารถกดซ้ำเพื่อเลือกได้หลายเขต</span>
              <div>
                <v-select multiple v-model="generalInfoSubmitData.select_districts"
                          class="custom-v-select"
                          :class="{'form-alert': errors.has('service_districts')}"
                          v-validate="'required'"
                          :options="serviceDistricts"
                          placeholder="กรุณาเลือกพื้นที่บริการ"
                          label="name_th"
                          ref="service_districts"
                          id="service_districts"
                          name="service_districts"
                          :selectable="option => !(option.id == 0)">

                  <template v-slot:option="option">
                    {{ option.name_th }}
                  </template>
                </v-select>

                <div v-if="errors.has('service_districts')" class="form-alert-text -status-alert">
                  กรุณาเลือกอำเภอ / เขต (ที่สะดวกรับงาน)
                </div>
              </div>
            </div>

            <div class="form-group my-4">
              <label>เพศ</label>
              <div class="select-jumbo">
                <select class="form-control" :class="{'form-alert': errors.has('gender')}"
                        v-model="generalInfoSubmitData.gender" name="gender" v-validate="'required'">
                  <option value="">โปรดระบุ</option>
                  <option :value="1">ชาย</option>
                  <option :value="2">หญิง</option>
                </select>
              </div>
              <div v-if="errors.has('gender')" class="form-alert-text -status-alert">กรุณาเลือกเพศ</div>
            </div>

            <div class="form-group my-4">
              <label>ระดับการศึกษา</label>
              <div class="select-jumbo">
                <select class="form-control" :class="{'form-alert': errors.has('education')}"
                        v-model="generalInfoSubmitData.education" name="education" v-validate="'required'">
                  <option value="">โปรดระบุ</option>
                  <option :value="1">ประถม</option>
                  <option :value="2">มัธยมต้น</option>
                  <option :value="3">มัธยมปลาย</option>
                  <option :value="4">ปวช.</option>
                  <option :value="5">ปวส.</option>
                  <option :value="6">ปริญญาตรี</option>
                  <option :value="7">ปริญญาโท</option>
                  <option :value="8">สูงกว่าปริญญาโท</option>
                </select>
              </div>
              <div v-if="errors.has('education')" class="form-alert-text -status-alert">กรุณาเลือกระดับการศึกษา</div>
            </div>

            <div class="form-group my-4">
              <label for="current_job">งานปัจจุบัน</label>
              <input type="text" id="current_job" v-validate="'required'"
                     class="form-control" v-model="generalInfoSubmitData.current_job"
                     :class="{'form-alert': errors.has('current_job')}"
                     name="current_job">
              <div v-if="errors.has('current_job')" class="form-alert-text -status-alert">กรุณากรอกงานปัจจุบัน</div>
            </div>

            <div class="form-group mt-4">
              <div class="mt-2">
                <h4>ท่านทราบข่าวการรับสมัครคุณแม่บ้านบีนีทจากที่ไหน</h4>
              </div>
            </div>
            <div class="form-group">
              <div class="mx-auto">
                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio" id="reference1"
                         v-model="generalInfoSubmitData.reference"
                         name="referrence_register"
                         v-validate="'required'"
                         value="Facebook">
                  <label class="form-check-label ml-2" for="reference1">
                    Facebook
                  </label>
                </div>
                <div class="form-check ml-3">
                  <input class="form-check-input"
                         name="referrence_register"
                         v-validate="'required'"
                         type="radio" id="reference2" v-model="generalInfoSubmitData.reference"
                         value="ค้นหาผ่าน Google">
                  <label class="form-check-label ml-2" for="reference2">
                    ค้นหาผ่านกูเกิล
                  </label>
                  <input type="text"
                         name="referenceGoogle"
                         class="form-control input-md my-2"
                         :class="{'form-alert': errors.has('referenceGoogle')}"
                         v-validate="'required'"
                         placeholder="(โปรดระบุคำที่ใช้ค้นหา)"
                         v-if="generalInfoSubmitData.reference.includes('ค้นหาผ่าน Google')"
                         v-model="referenceGoogle">
                </div>
                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio" id="reference3"
                         name="referrence_register"
                         v-validate="'required'"
                         v-model="generalInfoSubmitData.reference"
                         value="Line Job">
                  <label class="form-check-label ml-2" for="reference3">
                    Line Job
                  </label>
                </div>
                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio" id="reference4"
                         name="referrence_register"
                         v-validate="'required'"
                         v-model="generalInfoSubmitData.reference"
                         value="Youtube">
                  <label class="form-check-label ml-2" for="reference4">
                    Youtube
                  </label>
                </div>
                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio" id="reference5"
                         name="referrence_register"
                         v-validate="'required'"
                         v-model="generalInfoSubmitData.reference"
                         value="Twitter">
                  <label class="form-check-label ml-2" for="reference5">
                    Twitter
                  </label>
                </div>
                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio" id="reference11"
                         name="referrence_register"
                         v-validate="'required'"
                         v-model="generalInfoSubmitData.reference"
                         value="Tiktok">
                  <label class="form-check-label ml-2" for="reference11">
                    Tiktok
                  </label>
                </div>
                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio"
                         name="referrence_register"
                         v-validate="'required'"
                         id="reference6" v-model="generalInfoSubmitData.reference"
                         value="website">
                  <label class="form-check-label ml-2" for="reference6">
                    เว็บไซต์อื่น
                  </label>
                  <input type="text"
                         name="referenceWebsite"
                         class="form-control input-md my-2"
                         :class="{'form-alert': errors.has('referenceWebsite')}"
                         v-validate="'required'"
                         placeholder="(โปรดระบุชื่อเว็บไซต์)"
                         v-if="generalInfoSubmitData.reference.includes('website')"
                         v-model="referenceWebsite">
                </div>
                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio"
                         name="referrence_register"
                         v-validate="'required'"
                         id="reference10" v-model="generalInfoSubmitData.reference"
                         value="finnix">
                  <label class="form-check-label ml-2" for="reference10">
                    สินเชื่อมันนิกซ์
                  </label>
                  <input type="text"
                         name="finnixDiscount"
                         class="form-control input-md my-2"
                         :class="{'form-alert': errors.has('finnixDiscount')}"
                         v-validate="'required'"
                         placeholder="(โปรดระบุโค้ดส่วนลด)"
                         v-if="generalInfoSubmitData.reference.includes('finnix')"
                         v-model="finnixDiscount">
                </div>
                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio"
                         name="referrence_register"
                         v-validate="'required'"
                         id="reference7" v-model="generalInfoSubmitData.reference"
                         value="friend">
                  <label class="form-check-label ml-2" for="reference7">
                    เพื่อนแนะนำ
                  </label>
                  <input type="text"
                         name="referenceFriend"
                         class="form-control input-md my-2"
                         :class="{'form-alert': errors.has('referenceFriend')}"
                         v-validate="'required'"
                         placeholder="(โปรดระบุชื่อเพื่อน)"
                         v-if="generalInfoSubmitData.reference.includes('friend')"
                         v-model="referenceFriend">
                </div>
                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio"
                         name="referrence_register"
                         v-validate="'required'"
                         id="reference9" v-model="generalInfoSubmitData.reference"
                         value="แม่บ้านบีนีท">
                  <label class="form-check-label ml-2" for="reference9">
                    แม่บ้านบีนีท
                  </label>
                  <input type="text"
                         name="referenceProfessional"
                         class="form-control input-md my-2"
                         :class="{'form-alert': errors.has('referenceProfessional')}"
                         v-validate="'required'"
                         placeholder="(โปรดระบุชื่อหรือเบอร์โทรของคุณแม่บ้านที่แนะนำมา)"
                         v-if="generalInfoSubmitData.reference.includes('แม่บ้านบีนีท')"
                         v-model="referenceProfessional">
                </div>

                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio" id="reference12"
                         name="referrence_register"
                         v-validate="'required'"
                         v-model="generalInfoSubmitData.reference"
                         value="สำนักงานจัดหางาน">
                  <label class="form-check-label ml-2" for="reference12">
                    สำนักงานจัดหางาน (กรมแรงงาน)
                  </label>
                </div>

                <div class="form-check ml-3">
                  <input class="form-check-input" type="radio" id="reference8"
                         name="referrence_register"
                         v-validate="'required'"
                         v-model="generalInfoSubmitData.reference"
                         value="other">
                  <label class="form-check-label ml-2" style="width: 60px" for="reference8">
                    อื่น ๆ
                  </label>
                  <input type="text"
                         name="referenceOther"
                         class="form-control input-md my-2"
                         :class="{'form-alert': errors.has('referenceOther')}"
                         v-validate="'required'"
                         placeholder="(โปรดระบุ)"
                         v-if="generalInfoSubmitData.reference.includes('other')"
                         v-model="referenceOther">
                </div>
                <div v-if="errors.has('referenceWebsite')" class="form-alert-text -status-alert">กรุณาระบุเว็บไซต์</div>
                <div v-if="errors.has('referenceGoogle')" class="form-alert-text -status-alert">
                  กรุณาระบุคำที่ใช้ค้นหาใน Google
                </div>
                <div v-if="errors.has('referenceFriend')" class="form-alert-text -status-alert">กรุณาระบุชื่อเพื่อน</div>
                <div v-if="errors.has('referenceProfessional')" class="form-alert-text -status-alert">กรุณาระบุแม่บ้าน</div>
                <div v-if="errors.has('finnixDiscount')" class="form-alert-text -status-alert">กรุณาระบุส่วนลด</div>
                <div v-if="errors.has('referenceOther')" class="form-alert-text -status-alert">กรุณาระบุ</div>
              </div>

              <div v-if="errors.has('referrence_register')" class="form-alert-text -status-alert">กรุณาเลือกช่องทางรับทราบข่าวการสมัครคุณแม่บ้านบีนีท (อย่างน้อย 1 ช่อง)</div>
            </div>

            <div class="mt-4">
              <label>ประเภทของงานที่ต้องการให้บริการ (เลือกได้มากกว่า 1 ข้อ)</label>
            </div>
            <div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="checkbox" id="service1" v-model="generalInfoSubmitData.service"
                       value="งานทำความสะอาด">
                <label class="form-check-label ml-2" for="service1">
                  งานทำความสะอาด
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="checkbox" id="service2" v-model="generalInfoSubmitData.service"
                       value="งานรีดผ้า">
                <label class="form-check-label ml-2" for="service2">
                  งานรีดผ้า
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="checkbox" id="service3" v-model="generalInfoSubmitData.service"
                       value="เทอราปีส (นวดเพื่อสุขภาพ)">
                <label class="form-check-label ml-2" for="service3">
                  เทอราปีส (นวดเพื่อสุขภาพ)
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="checkbox" id="service4" v-model="generalInfoSubmitData.service"
                       value="งานดูแลสวน/ตัดหญ้า">
                <label class="form-check-label ml-2" for="service4">
                  งานดูแลสวน/ตัดหญ้า
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="checkbox" id="service5" v-model="generalInfoSubmitData.service"
                       value="งานผู้ฝึกสอนโยคะ">
                <label class="form-check-label ml-2" for="service5">
                  งานผู้ฝึกสอนโยคะ
                </label>
              </div>
            </div>


            <div class="mt-4">
              <label>ท่านสนใจงานทำความสะอาดแบบประจำด้วยหรือไม่ ?</label>
            </div>
            <div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="interest_regular_cleaning"
                       id="interest_regular_cleaning1"
                       v-model="interest_regular_cleaning"
                       :value="1"
                       v-validate="'required'">
                <label class="form-check-label ml-2" for="interest_regular_cleaning1">
                  สนใจ
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="interest_regular_cleaning"
                       id="interest_regular_cleaning2"
                       v-model="interest_regular_cleaning"
                       :value="0">
                <label class="form-check-label ml-2" for="interest_regular_cleaning2">
                  ไม่สนใจ
                </label>
              </div>
              <div v-if="errors.has('interest_regular_cleaning')" class="form-alert-text -status-alert">
                กรุณากรอกข้อมูลให้ครบถ้วน
              </div>
            </div>


            <div class="mt-4">
              <label>เคยทำอาชีพเกี่ยวกับทำความสะอาดหรือกำลังทำอาชีพนี้อยู่ในปัจจุบันหรือไม่ ?</label>
            </div>
            <div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="have_to_cleaner" id="have_to_cleaner1"
                       v-model="been_cleaner"
                       :value="1">
                <label class="form-check-label ml-2" for="have_to_cleaner1">
                  เคย
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="have_to_cleaner" id="have_to_cleaner2"
                       v-model="been_cleaner"
                       :value="0">
                <label class="form-check-label ml-2" for="have_to_cleaner2">
                  ไม่เคย
                </label>
              </div>
              <div v-if="errors.has('have_to_cleaner')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน
              </div>
            </div>


            <div class="mt-4">
              <label>ปัจจุบันท่านสูบบุหรี่หรือไม่ ?</label>
            </div>
            <div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="smoking" id="smoking1"
                       v-model="generalInfoSubmitData.smoking"
                       :value="1"
                       v-validate="'required'">
                <label class="form-check-label ml-2" for="smoking1">
                  สูบ
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="smoking" id="smoking2"
                       v-model="generalInfoSubmitData.smoking"
                       :value="0">
                <label class="form-check-label ml-2" for="smoking2">
                  ไม่สูบ
                </label>
              </div>
              <div v-if="errors.has('smoking')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน
              </div>
            </div>

            <div class="mt-4">
              <label>ปัจจุบันท่านดื่มแอลกอฮอล์หรือไม่ ?</label>
            </div>
            <div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="drink_alcohol" id="drink_alcohol1"
                       v-model="generalInfoSubmitData.drink_alcohol"
                       :value="1"
                       v-validate="'required'">
                <label class="form-check-label ml-2" for="drink_alcohol1">
                  ดื่มเป็นประจำ
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="drink_alcohol" id="drink_alcohol2"
                       v-model="generalInfoSubmitData.drink_alcohol"
                       :value="2">
                <label class="form-check-label ml-2" for="drink_alcohol2">
                  ไม่บ่อย (นานๆครั้ง)
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="drink_alcohol" id="drink_alcohol3"
                       v-model="generalInfoSubmitData.drink_alcohol"
                       :value="3">
                <label class="form-check-label ml-2" for="drink_alcohol3">
                  ไม่ดื่มแอลกอฮอล์
                </label>
              </div>
              <div v-if="errors.has('drink_alcohol')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน
              </div>
            </div>


            <!--            <div class="mt-4">
                          <label>ท่านเคยป่วยเป็นโรคร้ายแรงมาก่อนหรือไม่หรือไม่</label>
                        </div>
                        <div>
                          <div class="form-check ml-3">
                            <input class="form-check-input" type="radio" name="diseaseBool" id="diseaseBool1" v-model="diseaseBool"
                                   :value="1"
                                   v-validate="'required'">
                            <label class="form-check-label ml-2" for="diseaseBool1">
                              เคย
                            </label>
                            <input type="text"
                                   name="disease"
                                   class="form-control input-md my-2"
                                   :class="{'form-alert': errors.has('disease')}"
                                   v-validate="'required'"
                                   placeholder="(โปรดระบุ)"
                                   v-if="diseaseBool"
                                   v-model="generalInfoSubmitData.disease">
                            <div v-if="errors.has('disease')" class="form-alert-text -status-alert">กรุณาระบุชื่อโรคร้ายแรง</div>
                          </div>
                          <div class="form-check ml-3">
                            <input class="form-check-input" type="radio" name="diseaseBool" id="diseaseBool2" v-model="diseaseBool"
                                   :value="0">
                            <label class="form-check-label ml-2" for="diseaseBool2">
                              ไม่เคย
                            </label>
                          </div>
                          <div v-if="errors.has('diseaseBool')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน
                          </div>
                        </div>

                        <div class="mt-4">
                          <label>ท่านเคยมีประวัติอาชญากรรมมาก่อนหรือไม่? (ท่านที่เคยมีคดีบันทึกในประวัติไม่ว่าคดีใด ๆ
                            ทางบริษัทไม่สามารถพิจารณารับเป็นผู้ให้บริการได้)</label>
                        </div>
                        <div>
                          <div class="form-check ml-3">
                            <input class="form-check-input" type="radio" name="criminalHistory" id="criminalHistory1"
                                   v-model="generalInfoSubmitData.criminal_history" :value="1"
                                   v-validate="'required'">
                            <label class="form-check-label ml-2" for="criminalHistory1">
                              เคย
                            </label>
                          </div>
                          <div class="form-check ml-3">
                            <input class="form-check-input" type="radio" name="criminalHistory" id="criminalHistory2"
                                   v-model="generalInfoSubmitData.criminal_history" :value="0">
                            <label class="form-check-label ml-2" for="criminalHistory2">
                              ไม่เคย
                            </label>
                          </div>
                          <div v-if="errors.has('criminalHistory')" class="form-alert-text -status-alert">
                            กรุณากรอกข้อมูลให้ครบถ้วน
                          </div>
                        </div>
                        <div>
                          <input type="text"
                                 name="criminalHistory"
                                 class="form-control input-md my-2 ml-2"
                                 placeholder="(หมายเหตุ)"
                                 v-if="generalInfoSubmitData.criminal_history === 1"
                                 v-model="generalInfoSubmitData.criminal_history_remark">
                        </div>-->
          </div>

          <div class="form-group">
            <button class="button-large button-block -cyan" @click="submitInformation()" :disabled="isLoading">
              <label>ต่อไป</label>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="state === 1">
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <h3>แบบสอบถาม</h3>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-6 col-xs-12 mx-auto">
          <h4>1. เคยมีอาชีพแม่บ้านหรือพนักงานทำความสะอาดหรือไม่</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expType" id="expType1"
                   v-model="questionnaireSubmitData.exp_type" :value="1"
                   v-validate="'required'">
            <label class="form-check-label ml-2" for="expType1">
              เคย แบบเต็มเวลา
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expType" id="expType2"
                   v-model="questionnaireSubmitData.exp_type" :value="2">
            <label class="form-check-label ml-2" for="expType2">
              เคย แบบพาร์ทไทม์
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expType" id="expType3"
                   v-model="questionnaireSubmitData.exp_type" :value="0">
            <label class="form-check-label ml-2" for="expType3">
              ไม่เคย
            </label>
          </div>
          <div v-if="errors.has('expType')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน</div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-6 col-xs-12 mx-auto mt-2">
          <h4>2. ประสบการณ์ทำความสะอาดที่พัก</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expYear" id="expYear1"
                   v-model="questionnaireSubmitData.exp_year" :value="1"
                   v-validate="'required'">
            <label class="form-check-label ml-2" for="expYear1">
              น้อยกว่า 1 ปี
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expYear" id="expYear2"
                   v-model="questionnaireSubmitData.exp_year" :value="2">
            <label class="form-check-label ml-2" for="expYear2">
              1 - 2 ปี
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expYear" id="expYear3"
                   v-model="questionnaireSubmitData.exp_year" :value="3">
            <label class="form-check-label ml-2" for="expYear3">
              3 - 4 ปี
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expYear" id="expYear4"
                   v-model="questionnaireSubmitData.exp_year" :value="4">
            <label class="form-check-label ml-2" for="expYear4">
              5 ปีขึ้นไป
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expYear" id="expYear5"
                   v-model="questionnaireSubmitData.exp_year" :value="0">
            <label class="form-check-label ml-2" for="expYear5">
              ไม่มีประสบการณ์
            </label>
          </div>
          <div v-if="errors.has('expYear')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน</div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-6 col-xs-12 mx-auto mt-2">
          <h4>3. ประเภทที่พักที่เคยทำความสะอาด (เลือกได้มากกว่า 1 ข้อ)</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="expPlaceType1"
                   v-model="questionnaireSubmitData.exp_place_type" value="คอนโด/อพาร์ทเมนท์">
            <label class="form-check-label ml-2" for="expPlaceType1">
              คอนโด / อพาร์ทเมนท์
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="expPlaceType2"
                   v-model="questionnaireSubmitData.exp_place_type" value="บ้าน/ทาวน์โฮม">
            <label class="form-check-label ml-2" for="expPlaceType2">
              บ้าน / ทาวน์โฮม
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="expPlaceType3"
                   v-model="questionnaireSubmitData.exp_place_type" value="โรงแรม/รีสอร์ท">
            <label class="form-check-label ml-2" for="expPlaceType3">
              โรงแรม / รีสอร์ท
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="expPlaceType4"
                   v-model="questionnaireSubmitData.exp_place_type" value="สำนักงาน">
            <label class="form-check-label ml-2" for="expPlaceType4">
              สำนักงาน
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="expPlaceType5"
                   v-model="questionnaireSubmitData.exp_place_type" value="other">
            <label class="form-check-label ml-2" style="width: 60px" for="expPlaceType5">
              อื่น ๆ
            </label>
            <input type="text"
                   name="expPlaceTypeOther"
                   class="form-control input-md my-2"
                   :class="{'form-alert': errors.has('expPlaceTypeOther')}"
                   v-validate="'required'"
                   placeholder="(โปรดระบุ)"
                   v-if="questionnaireSubmitData.exp_place_type.includes('other')"
                   v-model="expPlaceTypeOther">
          </div>
          <div v-if="errors.has('expPlaceTypeOther')" class="form-alert-text -status-alert">กรุณาระบุประเภทที่พัก</div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-6 col-xs-12 mx-auto mt-2">
          <h4>4. ท่านเคยมีประสบการณ์งานทำความสะอาดผ่านบริษัทหรือแอพอื่นมาก่อนหรือไม่</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expCompanyBool" id="expCompanyBool1"
                   v-model="expCompanyBool" :value="1"
                   v-validate="'required'">
            <label class="form-check-label ml-2" for="expCompanyBool1">
              เคย
            </label>
            <div v-if="expCompanyBool">
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="expCompany" id="expCompany1"
                       v-model="questionnaireSubmitData.exp_company" value="Seekster"
                       v-validate="'required'">
                <label class="form-check-label ml-2" for="expCompany1">
                  Seekster
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="expCompany" id="expCompany2"
                       v-model="questionnaireSubmitData.exp_company" value="Fixzy">
                <label class="form-check-label ml-2" for="expCompany2">
                  Fixzy
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="expCompany" id="expCompany3"
                       v-model="questionnaireSubmitData.exp_company" value="ServisHero">
                <label class="form-check-label ml-2" for="expCompany3">
                  ServisHero
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="expCompany" id="expCompany4"
                       v-model="questionnaireSubmitData.exp_company" value="KnockDoor">
                <label class="form-check-label ml-2" for="expCompany4">
                  KnockDoor
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="expCompany" id="expCompany4"
                       v-model="questionnaireSubmitData.exp_company" value="bTaskee">
                <label class="form-check-label ml-2" for="expCompany6">
                  bTaskee
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="expCompany" id="expCompany5"
                       v-model="questionnaireSubmitData.exp_company" value="other">
                <label class="form-check-label ml-2" for="expCompany5">
                  อื่น ๆ
                </label>
                <input type="text"
                       name="expCompanyOther"
                       class="form-control input-md my-2"
                       :class="{'form-alert': errors.has('expCompanyOther')}"
                       v-validate="'required'"
                       placeholder="(โปรดระบุ)"
                       v-if="questionnaireSubmitData.exp_company === 'other'"
                       v-model="expCompanyOther">
              </div>
            </div>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="expCompanyBool" id="expCompanyBool2"
                   v-model="expCompanyBool" :value="0">
            <label class="form-check-label ml-2" for="expCompanyBool2">
              ไม่เคย
            </label>
          </div>
          <div v-if="errors.has('expCompanyBool')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน</div>
          <div v-if="errors.has('expCompany')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน</div>
          <div v-if="errors.has('expCompanyOther')" class="form-alert-text -status-alert">กรุณาระบุชื่อบริษัทหรือแอพ
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-6 col-xs-12 mx-auto mt-2">
          <h4>5. ช่วงเวลาที่สะดวกรับงาน</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="workPeriod" id="workPeriod1"
                   v-model="questionnaireSubmitData.work_period" :value="1"
                   v-validate="'required'">
            <label class="form-check-label ml-2" for="workPeriod1">
              สะดวกช่วง วันจันทร์ - วันศุกร์
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="workPeriod" id="workPeriod2"
                   v-model="questionnaireSubmitData.work_period" :value="2">
            <label class="form-check-label ml-2" for="workPeriod2">
              สะดวกช่วง วันเสาร์ - วันอาทิตย์
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="radio" name="workPeriod" id="workPeriod3"
                   v-model="questionnaireSubmitData.work_period" :value="3">
            <label class="form-check-label ml-2" for="workPeriod3">
              สะดวกทุกวัน
            </label>
          </div>
          <div v-if="errors.has('workPeriod')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน</div>
        </div>
      </div>

      <div class="mt-4">
        <div class="col-md-6 col-xs-12 mx-auto mt-2">
          <h4>6. ภาษาที่ท่านสามารถสื่อสารได้ (เลือกได้มากกว่า 1 ข้อ)</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language1" v-model="questionnaireSubmitData.language"
                   value="ไทย">
            <label class="form-check-label ml-2" for="language1">
              ไทย
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language2" v-model="questionnaireSubmitData.language"
                   value="อังกฤษ">
            <label class="form-check-label ml-2" for="language2">
              อังกฤษ
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language3" v-model="questionnaireSubmitData.language"
                   value="จีน">
            <label class="form-check-label ml-2" for="language3">
              จีน
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language4" v-model="questionnaireSubmitData.language"
                   value="ญี่ปุ่น">
            <label class="form-check-label ml-2" for="language4">
              ญี่ปุ่น
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language5" v-model="questionnaireSubmitData.language"
                   value="เยอรมัน">
            <label class="form-check-label ml-2" for="language5">
              เยอรมัน
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language6" v-model="questionnaireSubmitData.language"
                   value="รัสเซีย">
            <label class="form-check-label ml-2" for="language6">
              รัสเซีย
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language7" v-model="questionnaireSubmitData.language"
                   value="ฝรั่งเศส">
            <label class="form-check-label ml-2" for="language7">
              ฝรั่งเศส
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language8" v-model="questionnaireSubmitData.language"
                   value="เกาหลี">
            <label class="form-check-label ml-2" for="language8">
              เกาหลี
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language9" v-model="questionnaireSubmitData.language"
                   value="อินเดีย">
            <label class="form-check-label ml-2" for="language9">
              อินเดีย
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="language10" v-model="questionnaireSubmitData.language"
                   value="other">
            <label class="form-check-label ml-2" style="width: 60px" for="language10">
              อื่น ๆ
            </label>
            <input type="text"
                   name="languageOther"
                   class="form-control input-md my-2"
                   :class="{'form-alert': errors.has('languageOther')}"
                   v-validate="'required'"
                   placeholder="(โปรดระบุ)"
                   v-if="questionnaireSubmitData.language.includes('other')"
                   v-model="languageOther">
            <div v-if="errors.has('languageOther')" class="form-alert-text -status-alert">กรุณาระบุภาษา</div>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <div class="col-md-6 col-xs-12 mx-auto mt-2">
          <h4>7. ประสบการทำงานด้านอื่นๆ (เลือกได้มากกว่า 1 ข้อ)</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="work_exp1" v-model="questionnaireSubmitData.work_exp"
                   value="งานเลี้ยงเด็ก">
            <label class="form-check-label ml-2" for="work_exp1">
              งานเลี้ยงเด็ก
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="work_exp2" v-model="questionnaireSubmitData.work_exp"
                   value="ดูแลผู้สูงอายุ">
            <label class="form-check-label ml-2" for="work_exp2">
              ดูแลผู้สูงอายุ
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="work_exp3" v-model="questionnaireSubmitData.work_exp"
                   value="ดูแลผู้ป่วย">
            <label class="form-check-label ml-2" for="work_exp3">
              ดูแลผู้ป่วย
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="work_exp4" v-model="questionnaireSubmitData.work_exp"
                   value="แม่บ้านทำอาหาร">
            <label class="form-check-label ml-2" for="work_exp4">
              แม่บ้านทำอาหาร
            </label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" id="work_exp5" v-model="questionnaireSubmitData.work_exp"
                   value="other">
            <label class="form-check-label ml-2" style="width: 60px" for="work_exp5">
              อื่น ๆ
            </label>
            <input type="text"
                   name="workExpOther"
                   class="form-control input-md my-2"
                   :class="{'form-alert': errors.has('workExpOther')}"
                   v-validate="'required'"
                   placeholder="(โปรดระบุ)"
                   v-if="questionnaireSubmitData.work_exp.includes('other')"
                   v-model="workExpOther">
            <div v-if="errors.has('workExpOther')" class="form-alert-text -status-alert">กรุณาระบุประสบการณ์การทำงาน</div>
          </div>
        </div>
      </div>


      <div class="mt-4">
        <div class="col-md-6 col-xs-12 mx-auto mt-2">
          <h4>8. ความสามารถในการขับขี่ยานพาหนะ</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 mx-auto">

          <div class="row">
            <div class="col-12">
              <label>8.1 รถยนต์</label> <br>

              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" id="driving_exp1" v-model="questionnaireSubmitData.driving_car"
                       value="ขับได้มีใบขับขี่" v-validate="'required'" name="driving_car">
                <label class="form-check-label ml-2" for="driving_exp1">ขับได้มีใบขับขี่</label>

              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" id="driving_exp2" v-model="questionnaireSubmitData.driving_car"
                       value="ขับได้ไม่มีใบขับขี่" name="driving_car">
                <label class="form-check-label ml-2" for="driving_exp2">ขับได้ไม่มีใบขับขี่</label>

              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" id="driving_exp3" v-model="questionnaireSubmitData.driving_car"
                       value="ขับไม่ได้" name="driving_car">
                <label class="form-check-label ml-2" for="driving_exp3">ขับไม่ได้</label>
              </div>

              <div v-if="errors.has('driving_car')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน</div>
            </div>


          </div>

          <div class="row">
            <div class="col-12">
              <label>8.2 รถจักรยานยนต์</label> <br>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" id="driving_exp4" v-model="questionnaireSubmitData.driving_motorcycle"
                       value="ขับได้มีใบขับขี่" v-validate="'required'" name="driving_motorcycle">
                <label class="form-check-label ml-2" for="driving_exp4">ขับได้มีใบขับขี่</label>

              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" id="driving_exp5" v-model="questionnaireSubmitData.driving_motorcycle"
                       value="ขับได้ไม่มีใบขับขี่" name="driving_motorcycle">
                <label class="form-check-label ml-2" for="driving_exp5">ขับได้ไม่มีใบขับขี่</label>

              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" id="driving_exp6" v-model="questionnaireSubmitData.driving_motorcycle"
                       value="ขับไม่ได้" name="driving_motorcycle">
                <label class="form-check-label ml-2" for="driving_exp6">ขับไม่ได้</label>

              </div>
              <div v-if="errors.has('driving_motorcycle')" class="form-alert-text -status-alert">กรุณากรอกข้อมูลให้ครบถ้วน</div>

            </div>

          </div>

        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-6 col-xs-12 mx-auto">
          <div class="form-group">
            <button class="button-large button-block -cyan" @click.prevent="submitQuestionnaire()">
              <label>ต่อไป</label>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="state === 2">
      <div class="row">
        <div class="col-md-8 col-xs-12 mx-auto">
          <template v-if="generalInfoSubmitData.type !== 2">
            <div class="video-wrapper">
              <iframe src="https://player.vimeo.com/video/309827107" width="640" height="360" frameborder="0"
                      webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>
            <div class="video-wrapper">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/XgnuTLmSHcA" frameborder="0"
                      allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
          </template>
          <template v-else>
            <div class="text-center">
              <iframe src="https://www.tiktok.com/embed/7408368962855030023" width="600" height="800" frameborder="0" allowfullscreen></iframe>
            </div>
          </template>
          <p class="mt-4 text-center" style="font-weight: bold;">คุณได้กรอกข้อมูลครบถ้วนแล้วค่ะ</p>

          <template v-if="generalInfoSubmitData.type !== 2">
            <h3 class="text-center">ขั้นตอนต่อไป กรุณาเลือกศูนย์ฝึกอบรมและวันที่ต้องการเข้าอบรม</h3>
            <div class="select-jumbo">
              <select class="form-control" :class="{'form-alert': errors.has('trainingCenter')}"
                      v-model="selectedTrainingCenter"
                      name="trainingCenter" v-validate="'required'" @change="selectTrainingCenterHandler()">
                <option value="">เลือกศูนย์ฝึกอบรม</option>
                <option :value="trainingCenter" v-for="(trainingCenter, index) in trainingCenters" :key="index">
                  {{ trainingCenter.name }}
                </option>
              </select>
            </div>
            <div class="select-jumbo mt-3" v-if="selectedTrainingCenter">
              <select class="form-control" :class="{'form-alert': errors.has('trainingDate')}"
                      v-model="selectedTrainingDate"
                      name="trainingDate" v-validate="'required'">
                <option value="">เลือกวันที่อบรม</option>
                <template v-if="provinceId === 2">
                  <option :value="date" v-for="(date, index) in trainingDates" :key="index"
                          :disabled="Number(date.full) === 1">{{ date.date | prettyOnlyDate }} - {{
                      getTomorrowDate(date.date) | prettyOnlyDate
                    }} (อบรม 1 วัน) เวลา {{ date.start_time }} - {{
                      date.end_time
                    }} {{
                      (Number(date.full) === 1) ? '(เต็ม)' : (Number(date.remain) > 0 ? `(ว่าง
                  ${date.remain} ที่)` : '')
                    }}
                  </option>
                </template>
                <template v-else>
                  <option :value="date" v-for="(date, index) in trainingDates" :key="index"
                          :disabled="Number(date.full) === 1">{{ date.date | prettyOnlyDate }} {{ date.start_time }} - {{
                      date.end_time
                    }} {{
                      (Number(date.full) === 1) ? '(เต็ม)' : (Number(date.remain) > 0 ? `(ว่าง
                  ${date.remain} ที่)` : '')
                    }}
                  </option>
                </template>
              </select>
            </div>
            <h3 class="mt-4">สถานที่ฝึกอบรม</h3>
            <div v-if="selectedTrainingCenter">
              <p style="white-space: pre-wrap;">{{ selectedTrainingCenter.address }}</p>
            </div>
            <div v-else>
              <span class="text-mute">กรุณาเลือกสถานที่ฝึกอบรม</span>
            </div>
            <p class="text-muted mt-1">
              * การอบรมแต่ละรอบมีการจำกัดจำนวนที่นั่ง ทางบริษัทขอให้สิทธิ์ตามลำดับผู้สมัครที่ยืนยันการจองเข้าอบรมค่ะ
            </p>

            <p class="text-muted mt-2">
              ** หากต้องการความช่วยเหลือหรือสอบถามรายละเอียดเพิ่มเติม กรุณาติดต่อฝ่ายรับสมัครที่<br>
              - เชียงใหม่ติดต่อ <a href="tel:0625688997">062-5688997</a><br>
              - กรุงเทพ ปริมณฑล และจังหวัดอื่น ๆ ติดต่อ <a href="tel:0649952288">064-9952288</a> หรือ <a href="tel:0622917700">062-2917700</a><br><br>
              Line ID: <a href="https://line.me/R/ti/p/%40beneatpro" @click.prevent="openLineRegister">@BeNeatPro</a>
            </p>
          </template>
          <template v-else>

            <p class="text-muted mt-2">
              ** หากต้องการความช่วยเหลือหรือสอบถามรายละเอียดเพิ่มเติม กรุณาติดต่อฝ่ายรับสมัครคุณแม่บ้านประจำ<br>
              MIKU Agency <a href="tel:0632970492">063-297-0492</a>, <a href="tel:0621966190">062-196-6190</a><br>
              Line ID: <a href="https://line.me/R/ti/p/@164uxerr" @click.prevent="openLineRegister">@jobmaid</a>
            </p>
          </template>


        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-8 col-xs-12 mx-auto">
          <div class="form-group">
            <button class="button-large button-block -cyan" @click="submitTrainingDate()">
              <label>ต่อไป</label>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="state === 3">
      <div class="row">
        <div class="col-md-8 col-xs-12 mx-auto">
          <div class="video-wrapper">
            <iframe src="https://player.vimeo.com/video/325400198" width="640" height="360" frameborder="0"
                    webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-xs-12 mx-auto">
          <h3 class="text-left">กรุณาโอนชำระค่าจองที่นั่งเข้าอบรม 299 บาท (ส่วนที่เหลือชำระเพิ่มในวันอบรมงานค่ะ)
            และกรุณาแนบหลักฐานด้านล่าง</h3>
          <p class="text-left">
            หากขัดข้องกรุณาติดต่อเจ้าหน้าที่ฝ่ายรับสมัครที่ไลน์ <a href="https://line.me/R/ti/p/%40beneatpro"
                                                                   @click.prevent="openLineRegister">@BeNeatPro</a> ค่ะ
          </p>
          <p>
            หมายเหตุ: จำกัดจำนวนที่นั่งต่อรอบ ทางบริษัทขออนุญาตให้สิทธิ์ตามลำดับการแจ้งโอนค่ะ
          </p>
          <img src="/static/img/beneat-account.jpg" alt="" class="img-fluid">
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-8 col-xs-12 mx-auto">
          <div class="row mb-3">
            <div class="col-4">
              <label>สำเนาบัตรประชาชน</label>
            </div>
            <div class="col-md-8 col-xs-12">
              <template>
                <vue-core-image-upload
                  extensions="jpg,jpeg,png,gif"
                  class="btn btn-secondary"
                  :crop="false"
                  @imageuploaded="uploadedIdCard"
                  @imageuploading="uploadingIdCard"
                  @errorhandle="errorHandle"
                  :max-file-size="5242880"
                  :credentials="false"
                  :url="idCardURL"
                  :text="$t(isIdCardUploading)"/>
                <div class="text-remark mt-1">
                  {{ $t('message.bank_transfer.transfer_picture_remark01') }}<br>
                </div>
              </template>
              <div class="mt-2" v-if="idCardImageURL">
                <img :src="idCardImageURL" alt="สำเนาบัตรประชาชน" width="300">
              </div>
              <div class="mt-2" v-if="idCardUploadSuccess">
                <i class="fas fa-check-circle -status-accepted"></i>
                อัพโหลดไฟล์สำเร็จ
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-4">
              <label>สำเนาทะเบียนบ้าน</label>
            </div>
            <div class="col-md-8 col-xs-12">
              <template>
                <vue-core-image-upload
                  extensions="jpg,jpeg,png,gif"
                  class="btn btn-secondary"
                  :crop="false"
                  @imageuploaded="uploadedCensus"
                  @imageuploading="uploadingCensus"
                  @errorhandle="errorHandle"
                  :max-file-size="5242880"
                  :credentials="false"
                  :url="censusURL"
                  :text="$t(isCensusUploading)"/>
                <div class="text-remark mt-1">
                  {{ $t('message.bank_transfer.transfer_picture_remark01') }}<br>
                </div>
              </template>
              <div class="mt-2" v-if="censusImageURL">
                <img :src="censusImageURL" alt="สำเนาทะเบียนบ้าน" width="300">
              </div>
              <div class="mt-2" v-if="censusUploadSuccess">
                <i class="fas fa-check-circle -status-accepted"></i>
                อัพโหลดไฟล์สำเร็จ
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-4">
              <label>หลักฐานการโอนเงินค่าสมัคร</label>
            </div>
            <div class="col-md-8 col-xs-12">
              <template>
                <vue-core-image-upload
                  extensions="jpg,jpeg,png,gif"
                  class="btn btn-secondary"
                  :crop="false"
                  @imageuploaded="uploadedSlip"
                  @imageuploading="uploadingSlip"
                  @errorhandle="errorHandle"
                  :max-file-size="5242880"
                  :credentials="false"
                  :url="slipURL"
                  :text="$t(isSlipUploading)"/>
                <div class="text-remark mt-1">
                  {{ $t('message.bank_transfer.transfer_picture_remark01') }}<br>
                </div>
              </template>
              <div class="mt-2" v-if="slipImageURL">
                <img :src="slipImageURL" alt="หลักฐานการโอนเงินค่าสมัคร" width="300">
              </div>
              <div class="mt-2" v-if="slipUploadSuccess">
                <i class="fas fa-check-circle -status-accepted"></i>
                อัพโหลดไฟล์สำเร็จ
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-8 col-xs-12 mx-auto">
          <p class="text-muted">
            *หากท่านยังไม่สะดวกจัดเตรียมเอกสาร สามารถอัพโหลดเอกสารในภายหลัง <br>
            เพียงแค่คลิกที่ลิงก์สมัครแล้วกรอกเลขบัตรประชาชน <br>
            ระบบจะนําท่านเข้าสู่หน้านี้โดยอัตโนมัติให้อัพโหลดได้ค่ะหรือสามารถส่งเอกสารพร้อมสลิปให้เจ้าหน้าที่ทางไลน์ไอดี
            @beneatpro ค่ะ
          </p>
          <p class="text-muted">
            ** ติดต่อฝ่ายรับสมัคร ได้ที่ไลน์ไอดี @beneatpro (กดแอดไลน์อัตโนมัติ >> <a
            href="https://line.me/R/ti/p/%40beneatpro" @click.prevent="openLineRegister">@BeNeatPro</a>) <br>
            หรือเบอร์โทรติดต่อ <br>
            - เชียงใหม่ 062-5688997<br>
            - กรุงเทพ ปริมณฑล / จังหวัดอื่น 064-9952288 หรือ 062-2917700
          </p>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-8 col-xs-12 mx-auto">
          <div class="form-group">
            <button class="button-large button-block -cyan" @click="submitPicture()">
              <label>ต่อไป</label>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="state === 4">
      <div class="row">
        <div class="col-md-8 col-xs-12 mx-auto">
          <h2>กรุณากรอกข้อมูลเพิ่มเติมในหน้าแบบฟอร์มนี้</h2>
          <template v-if="isOtherInfoSaved">
            <h3>กรุณารอเจ้าหน้าที่ตรวจสอบเอกสารและติดต่อกลับภายใน 24 ชั่วโมงค่ะ</h3>
          </template>
          <template v-else>
            <h3>เพื่อให้เจ้าหน้าที่จัดเตรียมข้อมูลในระบบสำหรับการเข้าอบรมงาน <br>
              ***ข้อมูลของบิดาและมารดา ใช้เป็นข้อมูลในการส่งตรวจประวัติอาชญากรรม <br>
              หากท่านใดไปตรวจเองแล้วไม่จำเป็นต้องกรอกค่ะ ให้ใส่เครื่องหมาย - ได้เลยค่ะ</h3>
          </template>
          <div v-if="!isOtherInfoSaved">

            <div class="form-group my-4">
              <input type="text"
                     name="nickName"
                     class="form-control input-lg"
                     :class="{'form-alert': errors.has('nickName')}"
                     placeholder="ชื่อเล่น"
                     v-validate="'required'"
                     v-model="otherInfoSubmitData.nickname">
              <div v-if="errors.has('nickName')" class="form-alert-text -status-alert">กรุณากรอกชื่อเล่น</div>
            </div>

            <div class="mt-4">
              <label>ศาสนา</label>
            </div>
            <div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="religion" id="religion1"
                       v-model="otherInfoSubmitData.religion" value="พุทธ"
                       v-validate="'required'">
                <label class="form-check-label ml-2" for="religion1">
                  พุทธ
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="religion" id="religion2"
                       v-model="otherInfoSubmitData.religion" value="คริสต์">
                <label class="form-check-label ml-2" for="religion2">
                  คริสต์
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="religion" id="religion3"
                       v-model="otherInfoSubmitData.religion" value="อิสลาม">
                <label class="form-check-label ml-2" for="religion3">
                  อิสลาม
                </label>
              </div>
              <div class="form-check ml-3">
                <input class="form-check-input" type="radio" name="religion" id="religion4"
                       v-model="otherInfoSubmitData.religion" value="other">
                <label class="form-check-label ml-2" for="religion4">
                  อื่น ๆ
                </label>
                <input type="text"
                       name="religionOther"
                       class="form-control input-md my-2"
                       :class="{'form-alert': errors.has('religionOther')}"
                       v-validate="'required'"
                       placeholder="(โปรดระบุ)"
                       v-if="otherInfoSubmitData.religion === 'other'"
                       v-model="religionOther">
                <div v-if="errors.has('religionOther')" class="form-alert-text -status-alert">กรุณาระบุชื่อศาสนา</div>
              </div>
              <div v-if="errors.has('religion')" class="form-alert-text -status-alert">กรุณาระบุศาสนา</div>
            </div>


            <div class="form-group my-4">
              <label for="currentAddress">ที่อยู่ปัจจุบัน</label>
              <textarea id="currentAddress"
                        rows="4"
                        ref="currentAddress"
                        name="currentAddress"
                        class="form-control textarea-jumbo"
                        :class="{'form-alert': errors.has('currentAddress')}"
                        v-validate="'required'"
                        v-model="otherInfoSubmitData.current_address"></textarea>
              <div v-if="errors.has('currentAddress')" class="form-alert-text -status-alert">กรุณากรอกที่อยู่ปัจจุบัน
              </div>
            </div>
            <div class="form-group my-4">
              <label for="address">ที่อยู่ตามบัตรประชาชน</label>
              <textarea id="address"
                        rows="4"
                        ref="address"
                        name="address"
                        class="form-control textarea-jumbo"
                        :class="{'form-alert': errors.has('address')}"
                        v-validate="'required'"
                        v-model="otherInfoSubmitData.address"></textarea>
              <div v-if="errors.has('address')" class="form-alert-text -status-alert">กรุณากรอกที่อยู่ตามทะเบียนบ้าน
              </div>
            </div>

            <div class="row mt-4">
              <label>ชื่อ-นามสกุล บิดา</label>
            </div>
            <div class="row mb-4">
              <div class="col-md-3 col-xs-12 pl-0 pr-0" :class="{'pr-2': !$mq.phone, 'py-2': $mq.phone}">
                <select name="father_prefix_name" class="form-control" v-validate="'required'"
                        :class="{'form-alert': errors.has('father_prefix_name')}"
                        v-model="otherInfoSubmitData.father_prefix_name"
                >
                  <option value="">เลือกคำนำหน้าชื่อ</option>
                  <option v-for="(item,index) in prefixName" :value="item" :key="index">{{ item }}</option>

                </select>
                <div v-if="errors.has('father_prefix_name')" class="form-alert-text -status-alert">
                  กรุณาเลือกคำนำหน้าชื่อ บิดา
                </div>
              </div>

              <div class="col-md-4 col-xs-12 pl-0 pr-0" :class="{'pr-2': !$mq.phone, 'py-2': $mq.phone}">
                <input type="text"
                       name="fatherFirstName"
                       class="form-control input-lg"
                       :class="{'form-alert': errors.has('fatherFirstName')}"
                       placeholder="ชื่อบิดา"
                       v-validate="'required'"
                       v-model="otherInfoSubmitData.father_firstname">
                <div v-if="errors.has('fatherFirstName')" class="form-alert-text -status-alert">กรุณากรอกชื่อบิดา</div>
              </div>
              <div class="col-md-5 col-xs-12 pl-0 pr-0" :class="{'pl-2': !$mq.phone}">
                <input type="text"
                       name="fatherLastName"
                       class="form-control input-lg"
                       :class="{'form-alert': errors.has('fatherLastName')}"
                       placeholder="นามสกุลบิดา"
                       v-validate="'required'"
                       v-model="otherInfoSubmitData.father_lastname">
                <div v-if="errors.has('fatherLastName')" class="form-alert-text -status-alert">กรุณากรอกนามสกุลบิดา
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <label>ชื่อ-นามสกุล มารดา</label>
            </div>
            <div class="row mb-4">
              <div class="col-md-3 col-xs-12 pl-0 pr-0" :class="{'pr-2': !$mq.phone, 'py-2': $mq.phone}">
                <select name="mother_prefix_name" class="form-control" v-validate="'required'"
                        :class="{'form-alert': errors.has('mother_prefix_name')}"
                        v-model="otherInfoSubmitData.mother_prefix_name">
                  <option value="">เลือกคำนำหน้าชื่อ</option>
                  <option v-for="(item,index) in prefixName" :value="item" :key="index">{{ item }}</option>

                </select>
                <div v-if="errors.has('mother_prefix_name')" class="form-alert-text -status-alert">
                  กรุณาเลือกคำนำหน้าชื่อ บิดา
                </div>
              </div>


              <div class="col-md-4 col-xs-12 pl-0 pr-0" :class="{'pr-2': !$mq.phone, 'py-2': $mq.phone}">
                <input type="text"
                       name="motherFirstName"
                       class="form-control input-lg"
                       :class="{'form-alert': errors.has('motherFirstName')}"
                       placeholder="ชื่อมารดา"
                       v-validate="'required'"
                       v-model="otherInfoSubmitData.mother_firstname">
                <div v-if="errors.has('motherFirstName')" class="form-alert-text -status-alert">กรุณากรอกชื่อมารดา</div>
              </div>
              <div class="col-md-5 col-xs-12 pl-0 pr-0" :class="{'pl-2': !$mq.phone}">
                <input type="text"
                       name="motherLastName"
                       class="form-control input-lg"
                       :class="{'form-alert': errors.has('motherLastName')}"
                       placeholder="นามสกุลมารดา"
                       v-validate="'required'"
                       v-model="otherInfoSubmitData.mother_lastname">
                <div v-if="errors.has('motherLastName')" class="form-alert-text -status-alert">กรุณากรอกนามสกุลมารดา
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <label>ชื่อ-นามสกุลและเบอร์โทรติดต่อของบุคคลใกล้ชิดที่ทาง BeNeat สามารถติดต่อได้หากมีกรณีฉุกเฉิน</label>
            </div>
            <div class="row mt-2">
              <input type="text"
                     name="emergencyContactName"
                     class="form-control input-lg"
                     placeholder="ชื่อ-นามสกุล"
                     v-model="otherInfoSubmitData.emergency_contact_name">
            </div>
            <div class="row mt-2">
              <input type="text"
                     name="emergencyContactTel"
                     class="form-control input-lg"
                     placeholder="เบอร์โทร"
                     v-model="otherInfoSubmitData.emergency_contact_tel">
            </div>
            <div class="row mt-4 form-group">
              <button class="button-large button-block -cyan" @click="submitOtherInformation()">
                <label>บันทึก</label>
              </button>
            </div>
          </div>
          <p class="text-muted mt-4">
            ** หากต้องการความช่วยเหลือหรือสอบถามรายละเอียดเพิ่มเติม กรุณาติดต่อฝ่ายรับสมัครที่<br>
            - เชียงใหม่ติดต่อ 062-5688997<br>
            - กรุงเทพ ปริมณฑล และจังหวัดอื่น ๆ ติดต่อ 064-9952288 หรือ 062-2917700<br><br>
            Line ID: <a href="https://line.me/R/ti/p/%40beneatpro" @click.prevent="openLineRegister">@BeNeatPro</a>
          </p>
        </div>
      </div>
    </div>

    <div v-if="state === 5">
      <div class="row" v-if="trainingInfo">
        <div class="col-md-8 col-xs-12 mx-auto">
          <h2 class="text-align: center;">การจองเข้าอบรมเสร็จสมบูรณ์แล้ว</h2>
          <h3>วันที่ฝึกอบรม:</h3>
          <ul class="ml-4">
            <li>{{ trainingInfo.date | prettyOnlyDate }}
              {{ '(' + trainingInfo.start_time + ' - ' + trainingInfo.end_time + ')' }}
            </li>
          </ul>
          <h3>สถานที่ฝึกอบรม:</h3>
          <ul class="ml-4">
            <li>
              <p style="white-space: pre-wrap;">{{ trainingInfo.training_center.address }}</p>
            </li>
            <li>
              โปรดแต่งกายสุภาพ กรุณาสวมเสื้อสีเข้ม (ดำ หรือ กรม) รบกวนสวมรองเท้าหุ้มส้นหรือรองเท้าผ้าใบค่ะ
              กรุณานำถุงมือยางแบบหนายาวมาด้วย 1 คู่ พร้อมกับหน้ากากอนามัย และชุดตรวจ ATK ค่ะ
            </li>
          </ul>
          <div style="background-color: #92d7ef; padding: 1rem;">
            <h3>กรุณาดำเนินการดังต่อไปนี้:</h3>
            <h4>1. ท่านต้องการให้ BeNeat ช่วยอำนวยความสะดวกในการตรวจสอบประวัติอาชญากรรมให้หรือไม่?</h4>
            <div class="form-check ml-3">
              <input class="form-check-input" type="radio" name="criminalHistoryHelper" id="criminalHistoryHelper1"
                     v-model="criminalHistoryHelper" :value="1" @change="submitCriminalHistoryHelper">
              <label class="form-check-label ml-2" for="criminalHistoryHelper1">
                ต้องการให้ BeNeat ดำเนินการให้ (โปรดเตรียมค่าใช้จ่าย 150 บาทมาในวันฝึกอบรม)
              </label>
            </div>
            <div class="form-check ml-3">
              <input class="form-check-input" type="radio" name="criminalHistoryHelper" id="criminalHistoryHelper2"
                     v-model="criminalHistoryHelper" :value="0" @change="submitCriminalHistoryHelper">
              <label class="form-check-label ml-2" for="criminalHistoryHelper2">
                ท่านจะดำเนินการด้วยตนเอง (โปรดติดต่อสำนักงานตำรวจแห่งชาติ ค่าใช้จ่าย 100 บาท)
              </label>
            </div>

            <div class="row mt-2" v-if="criminalHistoryHelper === 0">
              <div class="card">
                <div class="card-body pl-5">
                  <ol>
                    <li>ผู้สมัครสามารถยื่นตรวจประวัติอาชญากรรมได้ที่สำนักงานตำรวจแห่งชาติ จะได้รับผลตรวจภายในวันเดียวกัน</li>
                    <li>เตรียมค่าธรรมเนียมการตรวจ 100 บาท</li>
                    <li>ใช้เอกสารคือบัตรประจำตัวประชาชน (นำสำเนาไปเผื่อด้วยค่ะ)</li>
                    <li>ให้แจ้งว่าขอตรวจประวัติเพื่อนำไปสมัครงาน (ไม่แจ้งว่าบริษัทให้มาตรวจนะคะ เพราะขั้นตอนจะยุ่งยาก และผู้สมัครไม่ได้เป็นพนักงานของบริษัทค่ะ)</li>
                  </ol>
                </div>
              </div>
            </div>

            <h4 class="mt-2">2. โปรดอัพโหลดหน้าสมุดบัญชีธนาคารกสิกร (หากยังไม่มีของธนาคารกสิกร กรุณาแจ้งเจ้าหน้าที่ฝ่ายรับสมัครทางไลน์ @beneatpro ค่ะ)</h4>
            <div class="row mb-3">
              <div class="col-4">
                <label>หน้าสมุดบัญชีธนาคาร</label>
              </div>
              <div class="col-md-8 col-xs-12">
                <template>
                  <vue-core-image-upload
                    extensions="png,jpeg,jpg"
                    class="btn btn-secondary"
                    :crop="false"
                    @imageuploaded="uploadedBookBank"
                    @imageuploading="uploadingBookBank"
                    @errorhandle="errorHandle"
                    :max-file-size="5242880"
                    :credentials="false"
                    :url="bookBankURL"
                    :text="$t(isBookBankUploading)"/>
                  <div class="text-remark mt-1">
                    {{ $t('message.bank_transfer.transfer_picture_remark01') }}<br>
                  </div>
                </template>
                <!-- <div class="mt-2" v-if="bookBankImageURL">
                  <img :src="bookBankImageURL" alt="หลักฐานการโอนเงินค่าสมัคร" width="300">
                </div> -->
                <div class="mt-2" v-if="bookBankUploadSuccess">
                  <i class="fas fa-check-circle -status-accepted"></i>
                  อัพโหลดไฟล์สำเร็จ
                </div>
              </div>
            </div>
            <h4 class="mt-2">3. กรุณาติดตั้ง Application นี้ในมือถือเพื่อความรวดเร็วในการฝึกอบรม</h4>
            <ul class="ml-4">
              <li>BeNeat Cleaner: <a href="https://play.google.com/store/apps/details?id=com.beneat.android"
                                     target="_blank">Android</a>, <a
                href="https://itunes.apple.com/th/app/beneat-cleaner/id1323965255" target="_blank">iOS</a>
                (ติดตั้งไว้ก่อนแต่ยังไม่ต้องทำอะไรค่ะ)
              </li>
            </ul>
          </div>
          <template v-if="videoURL">
            <div class="video-wrapper mt-4">
              <iframe :src="videoURL" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen
                      allowfullscreen></iframe>
            </div>
          </template>
          <template v-else>
            <div class="mt-4">
              <p>กรุณาใส่รหัส 12345 เพื่อเข้ารับชมวิดีโอค่ะ</p>
              <div class="form-group">
                <input type="password"
                       name="videoPassword"
                       class="form-control input-lg"
                       :class="{'form-alert': errors.has('videoPassword')}"
                       placeholder="รหัส"
                       v-validate="'required'"
                       v-model="videoPassword">
                <div v-if="errors.has('videoPassword')" class="form-alert-text -status-alert">กรุณากรอกรหัส</div>
              </div>
            </div>
            <div class="form-group">
              <button class="button-large button-block -cyan" @click="summitVideoPass()">
                <label>ยืนยันรหัส</label>
              </button>
            </div>
          </template>
          <p class="text-muted mt-2">
            ** หากต้องการความช่วยเหลือหรือสอบถามรายละเอียดเพิ่มเติม กรุณาติดต่อฝ่ายรับสมัครที่<br>
            - เชียงใหม่ติดต่อ 062-5688997<br>
            - กรุงเทพ ปริมณฑล และจังหวัดอื่น ๆ ติดต่อ 064-9952288 หรือ 062-2917700<br><br>
            Line ID: <a href="https://line.me/R/ti/p/%40beneatpro" @click.prevent="openLineRegister">@BeNeatPro</a>
          </p>
        </div>
      </div>
    </div>
    <!-- PDPA Consent modal -->
    <pdpa-consent-modal ref="pdpaConsentModal"/>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'
import VueCoreImageUpload from 'vue-core-image-upload'
import vSelect from 'vue-select'
import PdpaConsentModal from './PdpaConsentModal'

export default {
  components: {
    PdpaConsentModal,
    VueCoreImageUpload,
    'v-select': vSelect
  },
  data () {
    return {
      isAcceptPersonalInformation: 0,
      generalInfoSubmitData: {
        id_card_number: '',
        firstname: '',
        lastname: '',
        prev_firstname: '',
        prev_lastname: '',
        gender: '',
        education: '',
        current_job: '',
        tel: '',
        email: '',
        line: '',
        province_id: '',
        district_id: '',
        facebook: '',
        birthday: '',
        province_other: '',
        service: [],
        disease: '',
        title_th: '',
        select_districts: [],
        reference: [],
        type: 1
      },
      questionnaireSubmitData: {
        exp_type: '',
        exp_year: '',
        exp_place_type: [],
        exp_company: '',
        work_period: '',
        language: [],
        work_exp: [],
        driving_car: '',
        driving_motorcycle: ''
      },
      otherInfoSubmitData: {
        nickname: '',
        religion: '',
        current_address: '',
        address: '',
        father_prefix_name: '',
        father_firstname: '',
        father_lastname: '',
        mother_prefix_name: '',
        mother_firstname: '',
        mother_lastname: '',
        emergency_contact_name: '',
        emergency_contact_tel: '',
        smoking: null,
        drink_alcohol: null
      },
      can_drive: null,
      isOtherInfoSaved: false,
      religionOther: '',
      languageOther: '',
      workExpOther: '',
      diseaseBool: '',
      been_cleaner: '',
      interest_regular_cleaning: '',
      expPlaceTypeOther: '',
      expCompanyBool: '',
      expCompanyOther: '',
      referenceWebsite: '',
      referenceGoogle: '',
      referenceFriend: '',
      referenceProfessional: '',
      finnixDiscount: '',
      referenceOther: '',
      state: -1,
      id: '',
      provinceId: '',
      idCardNumber: '',
      idCardUploading: false,
      idCardUploadSuccess: false,
      idCardURL: '',
      idCardImageURL: '',
      censusUploading: false,
      censusUploadSuccess: false,
      censusURL: '',
      censusImageURL: '',
      slipUploading: false,
      slipUploadSuccess: false,
      slipURL: '',
      slipImageURL: '',
      bookBankUploading: false,
      bookBankUploadSuccess: false,
      bookBankURL: '',
      bookBankImageURL: '',
      selectedTrainingCenter: '',
      selectedTrainingDate: '',
      birthday: null,
      nameChanged: 0,
      videoPassword: '',
      videoURL: '',
      criminalHistoryHelper: '',
      isLoading: false,
      serviceDistricts: [],
      lineRegisterUrl: '',
      OpenIndicator: {
        render: createElement => createElement('span', '🔽', { class: { 'toggle': true } })
      },
      birthDateData: {
        birth_day: '',
        birth_month: '',
        birth_year: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      info: 'professionalRegister/getInfo',
      trainingCenters: 'professionalRegister/getTrainingCenters',
      trainingDates: 'professionalRegister/getTrainingDates',
      trainingInfo: 'professionalRegister/getTrainingInfo'
    }),
    ...mapState({
      prefixName: state => state.globalVal.prefixName,
      birthMonths: state => state.globalVal.months,
      professionalRegister: state => state.professionalRegister.professionalRegister
    }),
    isSelectProvince () {
      if (this.generalInfoSubmitData.province_id && parseInt(this.generalInfoSubmitData.province_id) !== 0) {
        return true
      }
      return false
    },
    isIdCardUploading () {
      return (this.idCardUploading) ? 'message.button.uploading' : 'message.button.upload_picture'
    },
    isCensusUploading () {
      return (this.censusUploading) ? 'message.button.uploading' : 'message.button.upload_picture'
    },
    isSlipUploading () {
      return (this.slipUploading) ? 'message.button.uploading' : 'message.button.upload_picture'
    },
    isBookBankUploading () {
      return (this.bookBankUploading) ? 'message.button.uploading' : 'message.button.upload_picture'
    },
    birthYears () {
      const now = (new Date().getUTCFullYear() - 17) + 543
      const years = Array(now - (now - 60)).fill('').map((v, idx) => now - idx)

      return years
    }
  },
  watch: {
    id () {
      if (this.id) {
        this.$refs.pdpaConsentModal.fetchPdpaConsent(this.id)
      }
    }
  },
  methods: {
    async fetchDistrict (provinceId) {
      // ถ้าเลือกกรุงเทพฝั่งธน ให้ยังเป็นจังหวัดกรุงเทพเช่นเดียวกัน
      provinceId = provinceId === 11 ? 1 : provinceId
      let { data } = await axios.get('professional-districts/' + provinceId)
      if (!data.error) {
        // Copy Deep Object
        this.serviceDistricts = data.service_districts

        // For Separate in option
        if (data.province_id === 1) {
          let bangkok = { id: 0, name_th: 'กรุงเทพมหานคร' }
          this.serviceDistricts.splice(0, 0, bangkok)
          let samutprakan = { id: 0, name_th: 'จังหวัดสมุทรปราการ' }
          this.serviceDistricts.splice(52, 0, samutprakan)
          let nontaburi = { id: 0, name_th: 'จังหวัดนนทบุรี' }
          this.serviceDistricts.splice(59, 0, nontaburi)
          let patumthani = { id: 0, name_th: 'จังหวัดปทุมธานี' }
          this.serviceDistricts.splice(68, 0, patumthani)
          let nakornpathom = { id: 0, name_th: 'จังหวัดนครปฐม' }
          this.serviceDistricts.splice(77, 0, nakornpathom)
          let samutsakorn = { id: 0, name_th: 'จังหวัดสมุทรสาคร' }
          this.serviceDistricts.splice(85, 0, samutsakorn)
        }
      }
    },
    async getDistrictById (districtId) {
      let { data } = await axios.get('/districts/' + districtId)
      if (!data.error) {
        return data.district
      }
    },
    changeProvince (event, provinceId = null) {
      if (!provinceId && event) {
        provinceId = parseInt(event.target.value)
      }

      try {
        this.generalInfoSubmitData.select_districts = JSON.parse(JSON.stringify([]))
        if (provinceId > 0) {
          this.fetchDistrict(provinceId)
        }
      } catch (e) {
        alert('ผิดพลาด ' + e.message)
      }
    },
    filterOnlyNumber (evt) {
      evt = evt || window.event
      let charCode = (evt.which) ? evt.which : evt.keyCode
      // เอาเฉพาะตัวเลข และไม่เอา - หรือ . หรือ +
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode === 46 || charCode === 45 || charCode === 43)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    updateBirthDay () {
      this.generalInfoSubmitData.birthday = moment(this.$refs.birthday.value, 'DD/MM/YYYY').format('YYYY-MM-DD')
    },
    submitPrepareState (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (!result) {
          this.$swal({
            text: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            type: 'error'
          })
          return false
        }
        // ถ้าไม่เจอเลขที่บัตรที่กรอกเข้ามาในระบบ จะเป็นการสร้างใหม่ โดยจะไป SET INFO ใน vuex
        // และ นำ info มาเช็คว่าเป็นค่าว่างรึเปล่า ถ้าใช่แปลว่า เป็นเลขที่บัตรใหม่
        this.$store.dispatch('professionalRegister/GET_REGISTRATION_INFO', {
          queryData: {
            id_card_number: this.idCardNumber,
            tel: this.generalInfoSubmitData.tel
          },
          handler: async (alertMismatchTelephone = null) => {
            // ถ้ามีเลขที่บัตรฯ ในระบบ แต่เบอร์ไม่ตรง - ไม่ให้เข้าระบบ
            if (alertMismatchTelephone) {
              this.$swal({
                title: 'ผิดพลาด',
                text: 'เบอร์โทรของคุณไม่ตรงกับที่ลงทะเบียนไว้ หากต้องการความช่วยเหลือกรุณาติดต่อเจ้าหน้าที่ผ่านช่องทาง LINE: @BeNeatPro (มีเครื่องหมาย @)',
                type: 'error'
              })
              return
            }

            if (this.info) {
              this.id = this.info.id
              this.state = Number(this.info.state)
              this.provinceId = Number(this.info.province_id)
              this.idCardURL = this.$http.options.root + '/professionals/register/' + this.id + '/save-id-card'
              this.censusURL = this.$http.options.root + '/professionals/register/' + this.id + '/save-census'
              this.slipURL = this.$http.options.root + '/professionals/register/' + this.id + '/save-slip'
              this.bookBankURL = this.$http.options.root + '/professionals/register/' + this.id + '/save-book-bank'
              if (this.info.id_card_uploaded) {
                this.idCardUploadSuccess = true
              }
              if (this.info.census_uploaded) {
                this.censusUploadSuccess = true
              }
              if (this.info.slip_uploaded) {
                this.slipUploadSuccess = true
              }
              if (this.info.book_bank_uploaded) {
                this.bookBankUploadSuccess = true
              }
              if (this.info.criminal_history_helper) {
                this.criminalHistoryHelper = Number(this.info.criminal_history_helper)
              }
              if (this.info.is_other_info_saved) {
                this.isOtherInfoSaved = true
              }
              if (this.info.line_register_url) {
                this.lineRegisterUrl = this.info.line_register_url
              }

              // ลงข้อมูลใน Form กรณีที่ผู้สมัครลงทะเบียนแบบ short มาแล้วเข้ามาเพื่อจะบันทึกข้อมูลที่เหลือต่อ
              if (this.professionalRegister) {
                this.generalInfoSubmitData.title_th = this.professionalRegister.title_th
                this.generalInfoSubmitData.firstname = this.professionalRegister.firstname
                this.generalInfoSubmitData.lastname = this.professionalRegister.lastname
                this.generalInfoSubmitData.tel = this.professionalRegister.tel

                this.generalInfoSubmitData.province_id = this.professionalRegister.province_id
                this.changeProvince(null, this.professionalRegister.province_id)
                if (this.professionalRegister.district_id) {
                  const district = await this.getDistrictById(this.professionalRegister.district_id)
                  this.generalInfoSubmitData.select_districts.push(district)
                }

                // สำหรับในการรอ element html โหลดให้มี input ก่อน
                setTimeout(() => {
                  if (this.professionalRegister.birthday) {
                    const arrDate = this.professionalRegister.birthday.split('-')
                    console.log('arrDate', arrDate)
                    // this.$refs.birthday.value = arrDate[2] + '/' + arrDate[1] + '/' + arrDate[0]
                    this.generalInfoSubmitData.birthday = this.professionalRegister.birthday
                    this.birthDateData.birth_year = (Number(arrDate[0]) + 543).toString()
                    this.birthDateData.birth_month = arrDate[1]
                    this.birthDateData.birth_day = arrDate[2]
                  }
                }, 1000)
              }

              if (this.state === 0) {
                this.generalInfoSubmitData.id_card_number = this.idCardNumber
                this.generalInfoSubmitData.tel = this.professionalRegister ? this.professionalRegister.tel : ''
              } else if (this.state === 2) {
                this.$store.dispatch('professionalRegister/GET_TRAINING_CENTERS', {
                  queryData: {
                    province_id: this.provinceId
                  }
                })
              } else if (this.state === 5) {
                this.$store.dispatch('professionalRegister/GET_TRAINING_INFO', {
                  queryData: {
                    id: this.id
                  }
                })
              }
            } else {
              this.state = 0
              this.generalInfoSubmitData.id_card_number = this.idCardNumber
            }
          }
        })
      })
    },
    submitInformation () {
      this.$validator.validateAll().then((result) => {
        if (!result || !this.generalInfoSubmitData.service.length) {
          this.$swal({
            text: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            type: 'error'
          })
          return false
        }
        let generalInfoSubmitData = { ...this.generalInfoSubmitData, state: 1, id: this.id }
        if (this.diseaseBool === 0) {
          generalInfoSubmitData.disease = 'ไม่เคย'
        }

        if (this.been_cleaner === 1) {
          generalInfoSubmitData.been_cleaner = 'เคย'
        } else {
          generalInfoSubmitData.been_cleaner = 'ไม่เคย'
        }

        generalInfoSubmitData.select_districts = this.generalInfoSubmitData.select_districts.map(item => item.id)
        generalInfoSubmitData.interest_regular_cleaning = this.interest_regular_cleaning
        generalInfoSubmitData.service = JSON.stringify(generalInfoSubmitData.service)

        let questionDetail = ''
        let questionSingle
        if (generalInfoSubmitData.reference === 'website' && this.referenceWebsite) {
          generalInfoSubmitData.reference = 'Website: ' + this.referenceWebsite
          questionDetail = this.referenceWebsite
          questionSingle = 'Website'
        } else if (generalInfoSubmitData.reference === 'ค้นหาผ่าน Google' && this.referenceGoogle) {
          generalInfoSubmitData.reference = 'Google: ' + this.referenceGoogle
          questionDetail = this.referenceGoogle
          questionSingle = 'Google'
        } else if (generalInfoSubmitData.reference === 'friend' && this.referenceFriend) {
          generalInfoSubmitData.reference = 'Friend: ' + this.referenceFriend
          questionDetail = this.referenceFriend
          questionSingle = 'Friend'
        } else if (generalInfoSubmitData.reference === 'finnix' && this.finnixDiscount) {
          generalInfoSubmitData.reference = 'Finnix: ' + this.finnixDiscount
          questionDetail = this.finnixDiscount
          questionSingle = 'Finnix'
        } else if (generalInfoSubmitData.reference === 'แม่บ้านบีนีท' && this.referenceProfessional) {
          generalInfoSubmitData.reference = 'แม่บ้านบีนีท: ' + this.referenceProfessional
          questionDetail = this.referenceProfessional
          questionSingle = 'แม่บ้านบีนีท'
        } else if (generalInfoSubmitData.reference === 'other' && this.referenceOther) {
          generalInfoSubmitData.reference = 'Other: ' + this.referenceOther
          questionDetail = this.referenceOther
          questionSingle = 'Other'
        } else {
          questionSingle = generalInfoSubmitData.reference
        }

        if (generalInfoSubmitData.reference) {
          generalInfoSubmitData.reference = JSON.stringify(generalInfoSubmitData.reference.split())
        }
        generalInfoSubmitData.reference_detail = questionDetail
        generalInfoSubmitData.reference_single = questionSingle

        // YYYY-MM-DD
        generalInfoSubmitData.birthday = (this.birthDateData.birth_year - 543) + '-' + this.birthDateData.birth_month + '-' + this.birthDateData.birth_day

        this.isLoading = true
        this.$store.dispatch('professionalRegister/SAVE_REGISTRATION_INFO', {
          submitData: generalInfoSubmitData,
          handler: (response) => {
            this.isLoading = false
            if (response.error) {
              this.$swal({
                text: 'พบข้อผิดพลาด กรุณาแจ้งเจ้าหน้าที่หรือลองใหม่อีกครั้ง',
                type: 'error'
              })
            } else {
              this.state = 1
              this.id = response.id
              this.provinceId = Number(this.generalInfoSubmitData.province_id)
              this.idCardURL = this.$http.options.root + '/professionals/register/' + this.id + '/save-id-card'
              this.censusURL = this.$http.options.root + '/professionals/register/' + this.id + '/save-census'
              this.slipURL = this.$http.options.root + '/professionals/register/' + this.id + '/save-slip'
              if (response.line_register_url) {
                this.lineRegisterUrl = response.line_register_url
              }
              window.scrollTo(0, 0)
              this.$store.dispatch('professionalRegister/GET_TRAINING_DATES', {
                queryData: {
                  province_id: this.generalInfoSubmitData.province_id
                }
              })
            }
          }
        })
      })
    },
    submitOtherInformation () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$swal({
            text: 'กรุณาระบุ ตามแบบฟอร์มที่ต้องการให้ครบถ้วน',
            type: 'error'
          })
          return false
        }
        let otherInfoSubmitData = { ...this.otherInfoSubmitData, id: this.id }
        if (otherInfoSubmitData.religion === 'other' && this.religionOther) {
          otherInfoSubmitData.religion = this.religionOther
        }
        this.$store.dispatch('professionalRegister/SAVE_REGISTRATION_INFO', {
          submitData: otherInfoSubmitData,
          handler: (response) => {
            if (response.error) {
              this.$swal({
                text: 'พบข้อผิดพลาด กรุณาแจ้งเจ้าหน้าที่หรือลองใหม่อีกครั้ง',
                type: 'error'
              })
            } else {
              this.$swal({
                text: 'บันทึกข้อมูลเรียบร้อย',
                type: 'success'
              })
              this.isOtherInfoSaved = true
            }
          }
        })
      })
    },
    submitQuestionnaire () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$swal({
            text: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            type: 'error'
          })
          return false
        }

        let questionnaireSubmitData = { ...this.questionnaireSubmitData, id: this.id, state: 2 }
        if (this.expCompanyBool === 0) {
          questionnaireSubmitData.exp_company = 'ไม่เคย'
        } else {
          if (questionnaireSubmitData.exp_company === 'other' && this.expCompanyOther) {
            questionnaireSubmitData.exp_company = this.expCompanyOther
          }
        }
        if (questionnaireSubmitData.exp_place_type.includes('other') && this.expPlaceTypeOther) {
          let index = questionnaireSubmitData.exp_place_type.indexOf('other')
          if (index >= 0) {
            questionnaireSubmitData.exp_place_type[index] = this.expPlaceTypeOther
          }
        }

        questionnaireSubmitData.exp_place_type = JSON.stringify(questionnaireSubmitData.exp_place_type)

        if (questionnaireSubmitData.language.includes('other') && this.languageOther) {
          let index = questionnaireSubmitData.language.indexOf('other')
          if (index >= 0) {
            questionnaireSubmitData.language[index] = this.languageOther
          }
        }
        questionnaireSubmitData.language = JSON.stringify(questionnaireSubmitData.language)

        if (questionnaireSubmitData.work_exp.includes('other') && this.workExpOther) {
          let index = questionnaireSubmitData.work_exp.indexOf('other')
          if (index >= 0) {
            questionnaireSubmitData.work_exp[index] = this.workExpOther
          }
        }
        questionnaireSubmitData.work_exp = JSON.stringify(questionnaireSubmitData.work_exp)

        this.openLineRegister()
        this.$store.dispatch('professionalRegister/SAVE_REGISTRATION_INFO', {
          submitData: questionnaireSubmitData,
          handler: (response) => {
            if (response.error) {
              this.$swal({
                text: 'พบข้อผิดพลาด กรุณาแจ้งเจ้าหน้าที่หรือลองใหม่อีกครั้ง',
                type: 'error'
              })
            } else {
              this.state = 2
              window.scrollTo(0, 0)
            }
          }
        })
      })
    },
    submitTrainingDate () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$swal({
            text: 'กรุณาเลือกสถานที่และวันที่ต้องการเข้าฝึกอบรม',
            type: 'error'
          })
          return false
        }

        let state = 3
        if (this.generalInfoSubmitData.type === 2) {
          // ถ้าเป็นผู้สมัคร Miku ให้ข้ามหน้าอัพโหลดสลิป
          // Ref: https://firework.beneat.co/tasks/12206
          state = 4
        }

        let submitData = {
          id: this.id,
          state: state,
          training_id: this.selectedTrainingDate.id,
          training_date: this.selectedTrainingDate.date
        }
        this.$store.dispatch('professionalRegister/SAVE_REGISTRATION_INFO', {
          submitData,
          handler: (response) => {
            if (response.error) {
              this.$swal({
                text: 'พบข้อผิดพลาด กรุณาแจ้งเจ้าหน้าที่หรือลองใหม่อีกครั้ง',
                type: 'error'
              })
            } else {
              this.state = state
              window.scrollTo(0, 0)
            }
          }
        })
      })
    },
    submitPicture () {
      if (!this.idCardUploadSuccess || !this.censusUploadSuccess || !this.slipUploadSuccess) {
        this.$swal({
          text: 'กรุณาอัพโหลดเอกสารให้ครบ',
          type: 'error'
        })
        return
      }
      this.$store.dispatch('professionalRegister/SAVE_REGISTRATION_INFO', {
        submitData: { id: this.id, state: 4 },
        handler: (response) => {
          if (response.error) {
            this.$swal({
              text: 'พบข้อผิดพลาด กรุณาแจ้งเจ้าหน้าที่หรือลองใหม่อีกครั้ง',
              type: 'error'
            })
          } else {
            this.state = 4
            window.scrollTo(0, 0)
            this.$store.dispatch('professionalRegister/GET_TRAINING_DATES', {
              queryData: {
                province_id: this.provinceId
              }
            })
          }
        }
      })
    },
    submitCriminalHistoryHelper () {
      this.$store.dispatch('professionalRegister/SAVE_REGISTRATION_INFO', {
        submitData: { id: this.id, criminal_history_helper: this.criminalHistoryHelper }
      })
    },
    summitVideoPass () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$swal({
            text: 'กรุณากรอกรหัสผ่าน',
            type: 'error'
          })
          return false
        }
        this.$store.dispatch('professionalRegister/VERIFY_VIDEO_PASSWORD', {
          submitData: { password: this.videoPassword },
          handler: (response) => {
            if (response.error) {
              this.$swal({
                text: 'รหัสของคุณไม่ถูกต้อง หากพบปัญหาในการรับชมวีดีโอโปรดติดต่อเจ้าหน้าที่',
                type: 'error'
              })
            } else {
              this.videoURL = response.video_url
            }
          }
        })
      })
    },
    uploadedIdCard (res) {
      this.idCardUploading = false
      if (!res.error) {
        this.idCardUploadSuccess = true
        this.idCardImageURL = res.image_url
      }
    },
    uploadingIdCard (res) {
      this.idCardUploading = true
    },
    uploadedCensus (res) {
      this.censusUploading = false
      if (!res.error) {
        this.censusUploadSuccess = true
        this.censusImageURL = res.image_url
      }
    },
    uploadingCensus (res) {
      this.censusUploading = true
    },
    uploadedSlip (res) {
      this.slipUploading = false
      if (!res.error) {
        this.slipUploadSuccess = true
        this.slipImageURL = res.image_url
      }
    },
    uploadingSlip (res) {
      this.slipUploading = true
    },
    uploadedBookBank (res) {
      this.bookBankUploading = false
      if (!res.error) {
        this.bookBankUploadSuccess = true
        this.bookBankImageURL = res.image_url
      }
    },
    uploadingBookBank (res) {
      this.bookBankUploading = true
    },
    errorHandle (res) {
      switch (res) {
        case 'TYPE ERROR':
          this.$swal({
            text: 'อัพโหลดได้เฉพาะไฟล์ JPG หรือ PNG',
            type: 'error'
          })
          break
        case 'FILE IS TOO LARGER MAX FILE IS 2.00MB':
          this.$swal({
            text: 'ไฟล์มีขนาดใหญ่เกินไป รองรับสูงสุด 2 MB',
            type: 'error'
          })
          break
        default:
          this.$swal({
            text: res,
            type: 'error'
          })
          break
      }
    },
    openLineRegister () {
      if (this.lineRegisterUrl) {
        window.open(this.lineRegisterUrl, '_blank')
      } else {
        window.open('https://line.me/R/ti/p/%40beneatpro', '_blank')
      }
    },
    getTomorrowDate (date) {
      return moment(date).add(1, 'days').format('YYYY-MM-DD')
    },
    checkValidationAndPassState () {
      this.$store.dispatch('professionalRegister/CHECK_STATE_AND_VALIDATION', {
        idProfessional: this.$route.query.idProfessional
      }).then(res => {
        this.idCardNumber = res.idCardNumber
        this.generalInfoSubmitData.tel = res.tel
        this.submitPrepareState('state-1')
      })
        .catch(err => {
          this.$swal({
            text: err,
            type: 'error'
          })
        })
    },
    selectTrainingCenterHandler () {
      if (!this.selectedTrainingCenter) {
        return
      }
      this.selectedTrainingDate = ''
      this.$store.dispatch('professionalRegister/GET_TRAINING_DATES', {
        queryData: {
          training_center_id: this.selectedTrainingCenter.id
        }
      })
    }
  },
  async mounted () {
    if (this.$route.query.type === '2') {
      this.generalInfoSubmitData.type = 2
    }
    this.$store.commit('professionalRegister/SET_INFO', null)
    this.$store.commit('professionalRegister/SET_PROFESSIONAL_REGISTER', null)
    setTimeout(() => {
      window.FB.CustomerChat.hide()
    }, 2000)

    if (this.$route.query.idProfessional) {
      this.checkValidationAndPassState()
    }
  }
}
</script>

<style scoped>
@import "~vue-select/dist/vue-select.css";
/*@import "~air-datepicker/dist/css/datepicker.min.css";*/

.custom-v-select .vs__dropdown-option--disabled {
  color: #000;
  font-weight: bold;
  padding: 3px 7px 4px;
  cursor: not-allowed;
}

.custom-v-select ul[role='listbox'] {
  border: 1px solid #5897fb;
  border-top: none;
}

.video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/professional/ProfessionalRegister.vue